import {makeStyles} from '@material-ui/core/styles'
import GroupCreateFormTemplate from '../../components/5templates/GroupCreateFormTemplate'
import DetailsLayout from '../../components/4layout/DetailsLayout'
import {AuthorizationError} from '../../components/1elements'
import {isAllowedToCreateNewGroup} from '../../services/util/permissionCheck'

const GroupCreateForm = () => {
    const classes = useStyles()
    const crudPermissionForGroup = isAllowedToCreateNewGroup()

    return (
        <DetailsLayout header={'Group Management'} subHeader={'Create Group'}>
            {crudPermissionForGroup
                    ? ( <GroupCreateFormTemplate />)
                    : (<AuthorizationError className={classes.errorDiv} />)}
        </DetailsLayout>
    )
}

export default GroupCreateForm

const useStyles = makeStyles({
    errorDiv: {
        gridColumn: '1/-1'
    }
})